import { trigger, transition, style, animate } from '@angular/animations';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-page-layout',
  templateUrl: './page-layout.component.html',
  styleUrls: ['./page-layout.component.scss'],
  animations: [
    trigger('menu', [
      transition(':enter', [
        style({ transform: 'translateX(-100%)' }),
        animate('.3s ease', style({ transform: 'translateX(0)' })),
      ]),
      transition(':leave', [
        style({ transition: 'translateX(0)' }),
        animate('.3s ease', style({ transform: 'translateX(-100%)' })),
      ]),
    ]),
  ],
})
export class PageLayoutComponent implements OnInit, OnDestroy {
  displayMenu = false;
  revealIOSInstructions = false;
  @Input() showFeatures = false;
  @Input() imageHeight = 416;
  @Input() imageContainerClass = '';
  @Input() layoutClass = '';
  @Input() imagePath = '/assets/banners/desktop/banner1.png';

  constructor(private route: ActivatedRoute, private router: Router) {
  }

  ngOnInit(): void {
    document.body.classList.add('bg-layout');
  }

  toggleMenu(val: boolean) {
    this.displayMenu = val;
  }

  closeIOS() {
    this.revealIOSInstructions = false;
  }

  showIOSInstructions() {
    this.revealIOSInstructions = true;
    this.toggleMenu(false);
  }

  ngOnDestroy(): void {
    document.body.classList.remove('bg-layout');
  }
}
